import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth-guard';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: './main/autenticacion/autenticacion.module#AutenticacionModule'
    },
   
    {
        path: 'cotizador',
        loadChildren: './main/cotizador/cotizador.module#CotizadorModule',
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: 'cotizador',
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule { }
